module.exports = __webpack_public_path__ + "static/media/服务管理体系认证.f36fbfc8.png";